var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BannerOpacity',{attrs:{"delay":"5000"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"welcome-page-container"},[_c('WelcomeIcons'),_vm._v(" "),_c('ContactForm',{staticClass:"contact-form-welcome-page"}),_vm._v(" "),_c('BrandsIcons',{attrs:{"pageCustom":[
            [480, 2],
            [768, 3],
            [1024, 4]
          ],"speed":3000}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba17973","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/WelcomePage.vue
// module id = null
// module chunks = 